import React, { useState } from 'react';
import { SectionHeader } from './SectionHeader';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Button } from './Button';
interface AccordionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}
function Accordion({
  title,
  children,
  defaultOpen = false
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className="border border-legal-border rounded-lg mb-4 overflow-hidden bg-white shadow-sm" data-id="element-57">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 flex justify-between items-center bg-legal-light hover:bg-gray-100 transition-colors text-left" data-id="element-58">
        <span className="text-lg font-bold text-legal-dark" data-id="element-59">{title}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-legal-red flex-shrink-0" data-id="element-60" /> : <ChevronDown className="w-5 h-5 text-legal-red flex-shrink-0" data-id="element-61" />}
      </button>
      {isOpen && <div className="px-6 py-6 border-t border-legal-border text-legal-gray prose max-w-none" data-id="element-62">
          {children}
        </div>}
    </div>;
}
export function DriverQualifications() {
  return <section className="py-16 bg-white border-t border-legal-border" data-id="element-63">
      <div className="max-w-legal-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64">
        <SectionHeader id="Driver-Qualifications" number="02" title="DRIVER QUALIFICATIONS" data-id="element-65" />

        <div className="mb-12" data-id="element-66">
          <Accordion title="Age:" data-id="element-67">
            <p data-id="element-68">
              Under the FMCSR, a driver must meet specific age requirements to
              operate a commercial motor vehicle in interstate commerce.
            </p>
          </Accordion>

          <Accordion title="Language:" data-id="element-69">
            <p data-id="element-70">
              Drivers must possess the ability to read and speak the English
              language sufficiently to converse with the general public,
              understand highway traffic signs and signals, respond to official
              inquiries, and make entries on reports and records.
            </p>
          </Accordion>

          <Accordion title="Operation of Motor Carrier:" data-id="element-71">
            <p data-id="element-72">
              The Operation of Motor Carrier regulations dictate that trucking
              companies must not require or permit a person to drive a
              commercial motor vehicle unless that person is qualified to drive.
            </p>
          </Accordion>

          <Accordion title="Valid Licensce:" data-id="element-73">
            <p data-id="element-74">
              A driver must possess a Valid Licensce issued by only one state or
              jurisdiction to operate a commercial motor vehicle under 49 C.F.R.
            </p>
          </Accordion>

          <Accordion title="Certifications:" data-id="element-75">
            <p data-id="element-76">
              Drivers must successfully complete required road tests and
              maintain valid medical examiner's certificates to prove they are
              physically qualified to drive.
            </p>
          </Accordion>

          <div className="mt-12 mb-8" data-id="element-77">
            <h3 className="text-2xl font-bold text-legal-dark mb-6 pl-4 border-l-4 border-legal-red" data-id="element-78">
              Driver Responsibility:
            </h3>

            <div className="space-y-6 pl-0 md:pl-8" data-id="element-79">
              <div className="bg-white p-6 rounded-lg border border-legal-border shadow-sm" data-id="element-80">
                <h4 className="text-xl font-bold text-legal-dark mb-3" data-id="element-81">
                  Hours of Service
                </h4>
                <p className="text-legal-gray" data-id="element-82">
                  Under <span className="font-semibold" data-id="element-83">§395.3</span>, drivers
                  are subject to strict maximum driving time limits to prevent
                  fatigue-related accidents.
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg border border-legal-border shadow-sm" data-id="element-84">
                <h4 className="text-xl font-bold text-legal-dark mb-3" data-id="element-85">
                  Truck Driver Logs
                </h4>
                <p className="text-legal-gray mb-6" data-id="element-86">
                  Drivers must maintain accurate Truck Driver Logs as required
                  by <span className="font-semibold" data-id="element-87">§395.8</span> to record
                  their duty status for each 24-hour period.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-88">
                  <div className="border border-legal-border rounded p-2 bg-gray-50" data-id="element-89">
                    <img src="https://drwzpk38qkpfb.cloudfront.net/www.truckaccidentlawyers-usa.com/uploaded/images/truckaccidentlawyers-usa.com/michigan1.JPG400x400.jpg" alt="Truck Driver Log Example 1" className="w-full h-auto rounded" data-id="element-90" />
                  </div>
                  <div className="border border-legal-border rounded p-2 bg-gray-50" data-id="element-91">
                    <img src="https://drwzpk38qkpfb.cloudfront.net/www.truckaccidentlawyers-usa.com/uploaded/images/truckaccidentlawyers-usa.com/michigan2.JPG400x400.jpg" alt="Truck Driver Log Example 2" className="w-full h-auto rounded" data-id="element-92" />
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 rounded-lg border border-legal-border shadow-sm" data-id="element-93">
                <h4 className="text-xl font-bold text-legal-dark mb-3" data-id="element-94">
                  Alcohol
                </h4>
                <p className="text-legal-gray" data-id="element-95">
                  Strict prohibitions regarding alcohol use and possession are
                  enforced under{' '}
                  <span className="font-semibold" data-id="element-96">§392.4-.5</span>.
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg border border-legal-border shadow-sm" data-id="element-97">
                <h4 className="text-xl font-bold text-legal-dark mb-3" data-id="element-98">
                  Truck Equipment & Repair
                </h4>
                <p className="text-legal-gray" data-id="element-99">
                  Drivers must be satisfied that the motor vehicle is in safe
                  operating condition under{' '}
                  <span className="font-semibold" data-id="element-100">§392.7</span>, ensure
                  emergency equipment is in place under{' '}
                  <span className="font-semibold" data-id="element-101">§392.8</span>, and carry
                  required emergency equipment per{' '}
                  <span className="font-semibold" data-id="element-102">§393.95</span>. Safe operation
                  is also mandated under{' '}
                  <span className="font-semibold" data-id="element-103">§392.6</span> and{' '}
                  <span className="font-semibold" data-id="element-104">§392.14</span>.
                </p>
              </div>
            </div>
          </div>

          <Accordion title="Disqualifications of Driver:" data-id="element-105">
            <p data-id="element-106">
              A driver can be disqualified from operating a commercial motor
              vehicle for various offenses under{' '}
              <span className="font-semibold" data-id="element-107">§383</span>.
            </p>
          </Accordion>

          <Accordion title="Law:" data-id="element-108">
            <p data-id="element-109">
              The general qualifications of drivers are established under{' '}
              <span className="font-semibold" data-id="element-110">§391</span> of the FMCSR.
            </p>
          </Accordion>
        </div>

        {/* Mid-section CTA */}
        <div className="bg-legal-dark rounded-lg p-8 text-center text-white shadow-lg mt-12" data-id="element-111">
          <h3 className="text-2xl font-bold mb-4" data-id="element-112">
            Did a driver violate these qualifications?
          </h3>
          <p className="text-gray-300 mb-6" data-id="element-113">
            Our attorneys investigate driver logs, background checks, and
            maintenance records to prove negligence.
          </p>
          <Button href="11014.html" variant="primary" icon="mail" data-id="element-114">
            Contact Us for a Free Consultation
          </Button>
        </div>
      </div>
    </section>;
}